/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 1/11/15
 * Time: 3:25 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Template = require("personalization-web-agent-templates/clickToVisitorPageMenuAnchor.tmpl");

    var BaseAnchorView = require("personalization-views/BaseAnchorView");

    var ClickToVisitorPageMenuAnchorView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        ClickToVisitorPageMenuAnchorView = BaseAnchorView.extend({
            className: "click-To-Visitor-Page-Menu-Anchor anchor",
            template: Template,
            withUIComponents: true,
            events:{
                "click":"_onClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing ClickToVisitorPageMenuAnchorView", "ClickToVisitorPageMenuAnchorView:initialize");
                BaseAnchorView.prototype.initialize.call(this, options);
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering ClickToVisitorPageMenuAnchorView", "ClickToVisitorPageMenuAnchorView:onRender");
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing ClickToVisitorPageMenuAnchorView", "ClickToVisitorPageMenuAnchorView:onClose");
            },

            /************************** Utility private functions that does not need "this" ********************/
            _onClick:function(){
                LE.vent.once(LE.mediaCodes.webAgent.vent.visitorTablesVisible, function(){
                    LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.hideSimulatedEngagement);
                    LEPersonalization.navigateToPageMenu();
                });

                LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.navigateToVisitorTables);
            }
        });
    });
    return ClickToVisitorPageMenuAnchorView;
});


